import './Layout.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <main className="layout-content">
        {children}
      </main>
    </div>
  );
}

export default Layout;